import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from './../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceServant } from '../servants/time/time_occurrence_servant';
import { WeekCalendarCellServant } from '../servants/week_calendar/week_calendar_servant';
import { IWeekCell } from '../views/week_calendar_view/data_types';

// put docstring here
function copyTimeOccurrenceToCellCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceServant: TimeOccurrenceServant,
  ngWeekCalendarCellServant: WeekCalendarCellServant,
  addBuiltTimeCommand: any,
  TimeOccurrenceBuilder: any,
  QueryMediator: IQueryMediator,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource
) {
  return defineCommand(
    'copyTimeOccurrenceToCellCommand',
    function copyTimeOccurrenceToCellCommand(
      deferred: ng.IDeferred<any>,
      cell: IWeekCell,
      currentTimeOccurrence: ITimeOccurrenceDatatype,
      originalTimeOccurrence: ITimeOccurrenceDatatype,
      deletedTimeOccurrence: ITimeOccurrenceDatatype
    ) {
      let builtTime: ITimeOccurrenceDatatype;
      const rawTime: IRawTimeOccurrenceDatatype = ngWeekCalendarCellServant.createTimeOccurrenceFromCellAndExistingTime(
        cell,
        currentTimeOccurrence,
        originalTimeOccurrence,
        deletedTimeOccurrence
      );

      builtTime = new TimeOccurrenceBuilder(rawTime);
      addBuiltTimeCommand(builtTime).then(function () {
        QueryMediator.runQueries(ngTimeOccurrenceDataSource);
        deferred.resolve(builtTime);
      });
    }
  );
}

angular.module('ui-ng-calendar').factory('copyTimeOccurrenceToCellCommand', copyTimeOccurrenceToCellCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/copy_time_occurrence_to_cell.ts